import ErrorSvg from 'assets/img/Error.svg';
import { Box, Flex, Text } from '@chakra-ui/react';
import styled from 'styled-components';
import { useHistory } from 'react-router-dom';

const Image = styled.img`
	max-height: 154px;
	width: 100%;
`;
const Title = styled.h2`
	color: ${(props) => props.theme.color.gray[80]};
	font-weight: ${(props) => props.theme.font.weight.semiBold};
	font-size: ${(props) => props.theme.size.rg2};
	line-height: 24px;
	text-align: center;
	margin-top: 10px;
`;
const SubTitle = styled.p`
	color: ${(props) => props.theme.color.gray[60]};
	font-weight: ${(props) => props.theme.font.weight.regular};
	line-height: 21px;
	text-align: center;
`;
const Link = styled.span`
	color: ${(props) => props.theme.color.primary};
	cursor: pointer;
	font-weight: 400;
`;

interface IErrorFallbackUiProps {
	error: any;
	hasGoback: boolean;
	refetch: any;
}
const ErrorFallbackUi = ({
	error,
	hasGoback,
	refetch,
}: IErrorFallbackUiProps) => {
	const history = useHistory();

	return (
		<Box
			height={'full'}
			width='full'
			display={'flex'}
			justifyContent='center'
			alignItems={'center'}
			bg='gray.100'
		>
			<Box p='rg2'>
				<Flex direction='column' alignItems='center'>
					<Image
						src={ErrorSvg}
						alt='Error'
						style={{ maxHeight: 154, width: '100%', height: '300px' }}
					/>
					<Title>Oh No! Something went wrong.</Title>
					<SubTitle>{error}</SubTitle>
					<br />
					<Text
						_hover={{ cursor: 'pointer' }}
						color='primary'
						p={2}
						fontWeight='bold'
						onClick={refetch}
					>
						Retry
					</Text>
					{hasGoback && <Link onClick={() => history.goBack()}>Go Back</Link>}
				</Flex>
			</Box>
		</Box>
	);
};
export default ErrorFallbackUi;
